import type { FaireCollectionEntity } from "../../entity_types/collection";

export const pbc_entuj9dc63: FaireCollectionEntity = {
  token: "pbc_entuj9dc63",
  type: "collection",
  name: "Berries & Cherries 🍓🍒",
  heroImageUrl:
    "https://cdn.faire.com/fastly/24fb7da1d092655d10362f26f862c22b1be65d08f8b1be05d46809b370cf9402.jpeg",
  itemCount: 21,
  description:
    "Sweet, playful, and full of charm, our Berries & Cherries Collection is bursting with juicy prints and cheerful colors! From darling cherries to sweet strawberries, these pieces are made for sunny days, twirls, and everyday fun.",
  brandToken: "b_gro99lye",
  productTokens: [],
  meta: {
    source: "api",
    importedAt: "2026-08-12T06:26:38.840Z",
    importedBy: "entity-db-import-collections",
  },
};
